module.exports = __webpack_public_path__ + "img/indexBanner.05f30fdb.png";